<template>
  <div v-if="loaded">
    <div v-if="!is_user_can_watch">
        <div id="unactive_screen" v-if="show_dets">
        <div class="bg" :style="'background-image:url('+ item.pic_hero_parsed +')'"></div>
        <div id="go_back_btn" class="tov_animate" @click="$router.go(-1)"><i class="material-icons dp48">keyboard_arrow_right</i></div>

        <div class="inner">



          <div style="color:#dd1a7b;">
            <div><b v-text="'היי ' + user_data.display_name + '.'"></b></div>
            <p>תוכן זה חסום לסוג המנוי שלך</p>
            <div>רוצה לצפות בכל התכנים בTOV?</div>
          
            <!-- <a class="btn" :href="'https://www.tov.tv/joinus/pay?token=' + user_token">סיימו את ההרשמה עכשיו</a> -->
            <a class="btn" @click="$emit('open_pay')"> הפכו לפרימיום</a>
          </div>

        </div>
      </div>
    </div>

  <div v-if="is_user_can_watch">

  <div v-show="loaded" id="video_page" :class="(is_episodes_bar_opened ? 'episodes_bar_opened' : '') + ' ' + (is_user_active ? 'user_active' : 'user_inactive')" @mousemove="user_hover()" @touchmove="user_hover()">

    <div id="episodes_bar" v-if="is_episodes_bar_opened">
      <h1>{{ item.title }}</h1>
      <div class="seasons_menu">
        עונות: <ul  v-scroll-spy-active="{class: 'active'}" v-scroll-spy-link><li v-for="season in seasons" :key="season.id" @click="scroll_to_season(season.id)">{{ season.num }}</li></ul>
      </div>

      <div class="episodes container" v-scroll-spy>
        
        <div v-for="season in seasons" :key="season.id" class="section" :id="'ep_season_' + season.id">
          <h3 class="title">עונה {{ season.num }}</h3>
          
          <div class="episode" v-for="episode_item in season.episodes" :key="episode_item.id" :class="(episode_item.id == episode.id ? 'active' : '')">
            <router-link :to="'/item/' + item.id + '/' + episode_item.id + '?autoplay=true'">
              <div class="pic" :style="'background-image:url(' + episode_item.pic_thumb_parsed + ')'">
                <div class="user_duration"><span :style="'width:' + episode_item.user_duration_perc + '%'"></span></div>
              </div>
            <div class="content">
              <h3>{{ episode_item.title }}</h3>
              <h4>{{ episode_item.description }}</h4>
            </div>
            
            </router-link>
            
          </div>

        </div>
      </div>

    </div>

  
<div id="chat" v-if="episode.is_chat == 1" :key="is_chat_open" :class="(is_chat_open ? '' : 'chat_close')">
  <div class="open_chat" v-if="is_mobile() && is_chat_open == false" @click="is_chat_open = true"><i class="fas fa-arrow-left"></i></div>
  <div class="open_chat" v-if="is_mobile() && is_chat_open == true" @click="is_chat_open = false"><i class="fas fa-arrow-right"></i></div>
     <Chat :episode="episode"  @open_pay="$emit('open_pay')" :active="is_user_can_watch"/>

</div>
    <div id="unactive_screen" v-if="!is_country_can_watch">
      <div class="bg" :style="'background-image:url('+ item.pic_hero_parsed +')'"></div>
      <router-link to="/" id="go_back_btn" class="tov_animate"><i class="material-icons dp48">keyboard_arrow_right</i></router-link>

      <div class="inner">
        <div style="color:#dd1a7b;">
          <div><b>היי {{user_data.display_name}}.</b></div>
          לצערנו השירות לא פועל במדינה שבה אתה נמצא.<br>
        </div>


      </div>
    </div>

      <div id="unactive_screen" v-if="item.restricted == true">
      <div class="bg" :style="'background-image:url('+ item.pic_hero_parsed +')'"></div>
      <router-link to="/" id="go_back_btn" class="tov_animate"><i class="material-icons dp48">keyboard_arrow_right</i></router-link>

      <div class="inner">
        <div style="color:#dd1a7b;">
          <div><b>היי {{user_data.display_name}}.</b></div>
          הסרט חסום לפי הגדרות הפרופיל שלך.<br>
        </div>


      </div>
    </div>

    <div id="video_wrapper" :class="(episode.is_chat == 1 ? 'small_video_wrapper' : '')" @mouseover="show_controls = true" @mouseleave="show_controls = false" v-if="is_user_can_watch">
      
          <div id="go_back_btn" class="tov_animate" @click="$router.go(-1)"><i class="material-icons dp48">keyboard_arrow_right</i></div>
            <div id="go_home_btn" class="tov_animate" @click="$router.replace('/')"><i class="material-icons dp48">home</i></div>
          <!--router-link to="/" id="go_back_btn" class="tov_animate"><i class="material-icons dp48">keyboard_arrow_right</i></router-link>-->
      
          <div id="rest_bubbles">
            
            <div class="restriction_item" v-if="player && is_playing &&  currentTime >= opening_starts && currentTime < opening_ends" @click="player.currentTime(opening_ends)">דלג על הפתיחה</div>
            
            <div class="restriction_item" v-if="player && is_playing && next_episode.id > 0 && currentTime >= ending_starts" @click="$router.push('/item/' + next_episode.item_id + '/' + next_episode.id)">עבור לפרק הבא</div>

            <div v-for="rest_item in rest_comp" :key="rest_item.id" class="restriction_item">
              <h3>{{ rest_item.cat.name }}</h3>
              <div class="content">{{ rest_item.description }}</div>
              <a class="btn" @click="player.currentTime(rest_item.time_end_seconds);">דלג</a>

            </div>
        
          </div>

          <div id="movie_titles">
            <h3 v-text="item.title"></h3>
            <h4 v-if="item.title != episode.title" v-text="episode.title"></h4>
          </div>

          <video ref="videoPlayer" class="video-js" autoplay>
          </video>
          
          <!-- <div id="video_controllers" v-if="show_controls">
            <div class="row">
              <div class="col-md-4 right-side">

                  <a @click="open_episodes_bar()">פרקים</a>

              </div>
              <div class="col-md-4 center">
                  <a class="play_btn" @click="player.play()">Play</a>
                  <a class="play_btn" @click="player.pause()">Stop</a>

                  <a @click="player.currentTime(player.currentTime() + 10)">דלג קדימה</a>
                  <a @click="player.currentTime(player.currentTime() - 10)">דלג אחורה</a>
  "

              </div>
              <div class="col-md-4 left-side">

                  <a @click="player.requestFullscreen()">מסך מלא</a>
                  <a>Volume</a>

              </div>
            </div>
          </div>
          -->


    </div>

  </div>
  </div>
   <md-dialog-prompt
      :md-active.sync="active_problam"
      v-model="problam_val"
      md-title="בואו תספרו לנו מה הבעיה?"
      md-input-maxlength="150"
      md-input-placeholder="הקלד/י את הבעיה..."
      @md-confirm="onConfirm_problam()"
      md-confirm-text="שלח"
      md-cancel-text="בטל" />
  </div>
</template>

<script>
import videojs from 'video.js';
import 'videojs-hotkeys';
import Chat from '../components/chat.vue';
//import { clearTimeout } from 'timers';

require('video.js/dist/video-js.min.css');
import 'videojs-youtube';

export default {
 /*
  props: {
      options: {
          type: Object,
          default() {
              return {};
          }
      }
  },
  */
 components:{Chat},
  props: ["user_data", "profile","country_code"],
  data() {
    return {
      updateInterval: false,
      user_token: localStorage.getItem('user_token'),
      auto_skip_rest: [],
      user_watch_time: 0,
      status: "",
      link: "/info/",
      coupon: "",
      problam_val: "",
      active_problam: false,
      coupon_active: false,
      show: true,
      show_dets: true,
      is_chat_open: true,
      is_user_active: false,
      is_user_active_timer: null,
      opening_starts: 0,
      opening_ends: 0,
      ending_starts: 0,
      show_controls: false,
      is_episodes_bar_opened: (this.$route.query.is_episodes_bar_opened == 'true'),
      player: null,
      loaded: false,
      appendRestDiv: 0,
      id: this.$route.params.id,
      eid: this.$route.params.eid,
      videoOptions: {
        //language: 'he',
        //poster: this.episode.pic_thumb_parsed,
        autoplay: true, // (this.$route.query.autoplay == 'true'),
				controls: true,
				sources: [
					{
						src: '', // this.episode.video,
						type: "video/mp4"
          }
          /*,
          {
            src: 'https://www.iandevlin.com/html5test/webvtt/upc-video-subtitles-en.vtt',
            type: ''
          }*/
				]
      },
      episode: {},
      seasons: [],
      item: {},
      cur_season: {},
      next_episode: {}
    };
  },
  computed: {
    is_user_can_watch(){
    
      if (this.episode.is_premium == '0') return true;

      if (this.get_me.is_active == true ) return true;
      
      return false;
    },

    
    is_country_can_watch(){
      return (this.country_code == 'IL');
    },
    is_playing() {
      if (this.isNull(this.player)) return false;
      return (this.player.currentTime() > 0 && this.player.paused() == false && this.player.ended() == false)
    },
    currentTime: {
      // getter
      get: function () { 
        //console.log(this.player.currentTime())
        return this.player.currentTime();
      },
      // setter
      set: function (newValue) {
        this.player.currentTime(newValue);
      }

    },
    rest_comp(){
      var arr = [];
      var pre_show_alert = 0;
      if (this.profile.perms_auto_skip == '0' && this.profile.perms_show_alerts == '1') pre_show_alert = 4;

      for (let z in this.episode.restrictions)
      { 
        for (let i in this.episode.restrictions[z].items)
        {
          let rest_item = this.episode.restrictions[z].items[i];
          
          if (this.player && this.currentTime >= (rest_item.time_start_seconds - pre_show_alert) && this.currentTime <= rest_item.time_end_seconds)
          {
            
            if (this.profile.perms_auto_skip == '1')
            {
             // console.log('shiktze');
              this.player.currentTime(rest_item.time_end_seconds+1);

              return;
            }
            else if (this.profile.perms_show_alerts == '1')
            {
              let thisincode = this; 
              if (thisincode.appendRestDiv == 0){
                    thisincode.appendRestDiv = 1;
                    let restapp = document.getElementById("rest_bubbles");
                    // let videoDiv =  document.getElementById("vjs_video_3");
                    let videoDiv =  document.querySelector(".video-js");
                    // let videoDiv =  document.querySelector(".vjs-control-bar");
                    videoDiv.append(restapp);
                    // console.log("skip");
                  // videoDiv.insertBefore(restapp, videoDiv.childNodes[0]);
                    // with jquery $('#rest_bubbles').appendTo($('#vjs_video_3'));
              }
             rest_item.cat = this.episode.restrictions[z].data.name;
              arr.push(rest_item);
            }
          }
        }
      } 
      return arr;
    },

    
    
  },
  beforeRouteLeave (to, from , next) {
    clearInterval(this.updateInterval);
    this.save_user_watch_time();
    next();
/*
    const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
    if (answer) {
      next()
    } else {
      next(false)
    }
    */
  },
  methods: {
   onConfirm_problam(){
     var self = this;
 this.api_call({ url: 'problem', data: { uid: this.get_me.id, eid: this.eid ,message:this.problam_val}, onComplete: function(){
   self.$alert("הודעתך נשלחה בהצלחה!");
 }})
   },
  
    scroll_to_season(id){


var container = this.$el.querySelector(".episodes.container");

var elm = this.$el.querySelector("#ep_season_" + id);
container.scrollTop = elm.offsetTop;

    },
    user_hover(){
      var self = this;
      self.is_user_active = true;

      window.clearTimeout(this.is_user_active_timer);

      this.is_user_active_timer = setTimeout(() => {
        self.is_user_active = false;
      }, 2400);
    },
    save_user_watch_time(){

      var settings = { 
        profile_id: this.profile.id, 
        episode_id: this.item.episode.id, 
        not_free_user:(this.get_me.is_active ? 1 : 0),
        item_id: this.item.episode.item_id, 
        season_id: this.item.episode.season_id, 
        duration: this.user_watch_time,
        api_user_token: localStorage.getItem('user_token')
      };

      //console.log(this.item)

      this.$http.post(window.api_url + 'user/update_time', settings)
      .then(function(/*data*/){
        
        //console.log('time saved');
        
      });

    },


    init_player(){

        if (!this.is_user_can_watch) return;

        var self = this;

        self.videoOptions.poster = self.episode.pic_thumb_parsed;

        let type = (self.episode.video.search('m3u8') != -1 ? "application/x-mpegURL" : 'video/mp4');
        if (self.episode.video.search('youtube') != -1) type = 'video/youtube'

        self.videoOptions.sources = [
          { 
            src: (self.episode.video != '' ? self.episode.video : ''),
            type: type
          }
        ];

      // self.videoOptions.plugins = { newButton : {} };

        self.videoOptions.controlBar= {
                children: [
                    'progressControl',
                    //'VolumePanel',
                    'CurrentTimeDisplay',
                    'TimeDivider',
                    'DurationDisplay',
                    'ProgressControl',
                    'LiveDisplay',
                  // 'SeekToLive',
                    'RemainingTimeDisplay',
                    'CustomControlSpacer',
                    'PlaybackRateMenuButton',
                    'ChaptersButton',
                    'DescriptionsButton',
                    //'SubsCapsButton',
                    'AudioTrackButton',
                    //'PictureInPictureToggle',
                    //'FullscreenToggle',
                ]
            }
    


        var saved_skip = JSON.parse(localStorage.getItem('user_restrictions'));
        var rest_comp = [];

        for (let z in self.episode.restrictions)
        {
          for (let i in self.episode.restrictions[z].items)
          {
            rest_comp.push( self.episode.restrictions[z].items[i] );
        }
          
        }

        for (let i in rest_comp)
        {
          if (!self.isNull(saved_skip) && saved_skip[rest_comp[i].id] === true)
          {
            self.auto_skip_rest.push(rest_comp[i]);
          }
        }

        videojs.addLanguage('en', {
          "captions off": "ללא כתוביות"
        });

        self.player = videojs(self.$refs.videoPlayer, self.videoOptions, function onPlayerReady() {
          // console.log('onPlayerReady', this);

          for (let i in self.episode.srt_list)
          {

            let srt = self.episode.srt_list[i];

            self.player.addRemoteTextTrack({ 
              label: srt.name , 
              kind: 'subtitles',
              language: srt.key,
              src: srt.url, //'https://storage.netflix.bagelcms.com/texttracks/upc-video-subtitles-en.vtt.txt', 
              default: true
            });
          // break;
          }
          // if already watched
          if (self.episode.user_duration > 0)
          {
            setTimeout(function(){ self.currentTime = self.episode.user_duration; }, 200);
          } 

          // dev
          //self.player.volume(0);

          self.player.on('timeupdate', function(){ 
            
            self.user_watch_time = self.currentTime;

            //console.log(self.auto_skip_rest);
            for (let i in self.auto_skip_rest)
            {
              let rest_item = self.auto_skip_rest[i];
              // console.log(rest_item)
              if (self.currentTime >= rest_item.time_start_seconds && self.currentTime <= rest_item.time_end_seconds)
              {
                self.currentTime = rest_item.time_end_seconds;
              }
            }

          });

          self.player.on('pause', function(){ self.save_user_watch_time(); });
          self.player.on('ended', function(){ self.save_user_watch_time(); });
          
          self.updateInterval = setInterval(function(){ 
            if(self.is_playing) self.save_user_watch_time(); 
          }, 15000);

        });
  /*
        self.player.addLanguage('en', {
          "captions off": "ללא כתוביות"
        });
  */
        self.player.hotkeys({
          volumeStep: 0.1,
          seekStep: 5,
          enableModifiersForNumbers: false
        });

            /*
        self.player.seekButtons({
          forward: 10,
          back: 10
        });
  */
        var obj = self;



      var info_btn = videojs.extend(videojs.getComponent('Button'), {
        handleClick: function(){

          obj.$router.push('/info/' + obj.item.id);
        }
      });
      var problam_btn = videojs.extend(videojs.getComponent('Button'), {
        handleClick: function(){
          obj.active_problam = true;
          }
      });

      // RIGHT GROUP
      var open_espisodes_btn = videojs.extend(videojs.getComponent('Button'), {
        handleClick: function(){
          obj.is_episodes_bar_opened = !obj.is_episodes_bar_opened;
        }
      });
      var next_episode_btn = videojs.extend(videojs.getComponent('Button'), {
        handleClick: function(){
          obj.$router.push('/item/' + obj.next_episode.item_id + '/' + obj.next_episode.id)
        }
      });
      var episode_name = videojs.extend(videojs.getComponent('Button'));

      // LEFT GROUP 
      self.player.controlBar.left_group = self.player.controlBar.addChild('Component');
      self.player.controlBar.left_group.addClass('left_group');

      self.player.controlBar.left_group.addChild(new info_btn()).addClass('info-btn');
      self.player.controlBar.left_group.addChild('FullscreenToggle');
      if (!self.is_mobile()) self.player.controlBar.left_group.addChild('PictureInPictureToggle');
      self.player.controlBar.left_group.addChild('SubsCapsButton');
      if (!self.is_mobile()) self.player.controlBar.left_group.addChild('VolumePanel');
      if (!self.is_mobile()) self.player.controlBar.left_group.addChild(new problam_btn()).addClass('problam_btn');

      self.player.controlBar.el().append(
        self.player.controlBar.left_group.el(),
        self.player.controlBar.el().firstChild.nextSibling
      );


      // CENTER GROUP
      self.player.controlBar.center_group = self.player.controlBar.addChild('Component');
      self.player.controlBar.center_group.addClass('center_group');

      
      self.player.controlBar.center_group.addChild('seekButton', { direction: 'back', seconds: 10 });
      self.player.controlBar.center_group.addChild('PlayToggle');
      self.player.controlBar.center_group.addChild('seekButton', { direction: 'forward', seconds: 10 });

      self.player.controlBar.el().append(
        self.player.controlBar.center_group.el(),
        self.player.controlBar.el().firstChild.nextSibling
      );



      // RIGHT GROUP
      self.player.controlBar.right_group = self.player.controlBar.addChild('Component');
      self.player.controlBar.right_group.addClass('right_group');

      if (obj.next_episode && obj.next_episode.id > 0) self.player.controlBar.right_group.addChild(new next_episode_btn()).addClass('next-episode-btn'); 
      if (obj.item.type == 'series') self.player.controlBar.right_group.addChild(new open_espisodes_btn()).addClass('open-espisodes-btn'); 

      self.player.controlBar.right_group.addChild(new episode_name()); 


      self.player.controlBar.el().append(
        self.player.controlBar.right_group.el(),
        self.player.controlBar.el().firstChild.nextSibling
      );
      
    }
  
  },
  /*
    mounted() {
        this.player = videojs(this.$refs.videoPlayer, this.options, function onPlayerReady() {
            console.log('onPlayerReady', this);
        })
    },*/
    beforeDestroy() {
        if (this.player) {
            this.player.dispose()
        }
    },
  mounted() {

    var self = this;
    self.$emit('show_loader');
      
    // promoted
    this.api_call({ url: 'items/get', data: { id: this.id, eid: this.eid }, onComplete: function(data){
  
      self.seasons = data.data.data.seasons;
      self.cur_season = self.seasons[0];
     

      
      self.item = data.data.data;
      
      self.episode = data.data.data.episode;

      self.opening_starts = self.episode.opening_starts;
      self.opening_ends = self.episode.opening_ends;

      if (self.episode.ending_starts > 0) self.ending_starts = self.episode.ending_starts;
      else self.ending_starts = self.episode.duration * 0.98;

      var curr_episode_found = false;
      for (var i in data.data.data.seasons)
      {
        for (var ep_i in data.data.data.seasons[i].episodes)
        {
          if (curr_episode_found)
          {
            self.next_episode = data.data.data.seasons[i].episodes[ep_i];
            break;
          }
          curr_episode_found = (data.data.data.seasons[i].episodes[ep_i].id == data.data.data.episode.id);
        }
        if (self.next_episode.id > 0) break;
      }


//console.log(self.player.controlBar)


      self.loaded = true;
      self.$emit('loaded');

      
      setTimeout(() => {
        self.init_player(); 
      }, 300);   if(!self.is_user_can_watch)
        {
          window.location.href = '' +self.link+ self.id+'';
        }
       
      } } );
    
  }
}
</script>

<style lang="scss">
.open_chat{height: 44px;width: 35px;background: #eee;position: absolute;top: 85px;left: -40px;color: #000;line-height: 40px;text-align: center;cursor: pointer;}
.chat_close{right: -227px !important;transition: 2s all ease-in-out;}
#chat{position: absolute;z-index: 99999;top: -25px;right: 0;bottom:-25px;width: 20%;min-width: 300px;transition: 2s all ease-in-out;}

.small_video_wrapper{width: 80%;float: left;}
#go_back_btn{padding: 0 !important;    position: absolute;top: 0 !important;right: 0;z-index: 5;height: 50px;width: 50px;background: #fff;color: #000;text-align: center;line-height: 62px;cursor: pointer;}
#go_home_btn{padding: 0 !important;    position: absolute;top: 0 !important;right: 50px;z-index: 5;height: 50px;width: 50px;background: #fff;color: #000;text-align: center;line-height: 62px;cursor: pointer;border-right: 1px solid #000;}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
#unactive_screen{width: 50%;margin: 0 auto;padding: 30px;margin-top: 100px;text-align: center;font-size: 25px;}
.container { position: relative; height: 400px; overflow: auto; }
/*
@media screen and (min-width: 320px) and (max-width: 767px) and (orientation: portrait) {
  #app {
    transform: rotate(-90deg);
    transform-origin: left top;
    width: 100vh;
    height: 100vw;
    overflow-x: hidden;
    position: absolute;
    top: 100%;
    left: 0;
  }
}
*/


</style>
